import React, { useState, useEffect } from "react"
import Loading from "../components/layouts/Loading/Loading"
import { Helmet } from "react-helmet"
import PlanView from "@fitpeo/fit-plan-viewer"
import { TempAxiosGet } from "../utils/TokenStorage"
import { convertCareplanToV2 } from "../utils/careplanVersioning"
import { Typography } from "antd"
import { getDateOfService } from "../utils/getDateOfService"

const MobilePCM = () => {
    const [patientInfoDetail, setPatientInfoDetail] = useState(null)
    const [carePlanData, setCarePlanData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [firstCall, setFirstCall] = useState(false)
    const [providers, setProviders] = useState(null)
    const [practitioners, setPractitioners] = useState(null)
    const [icdCodes, setIcdCodes] = useState(null)

    // useEffect(() => {
    //     setLoading(true)
    //     const timer = setTimeout(() => {
    //         if (window.value !== undefined && window.token !== undefined && firstCall === false) {
    //                 //dispatch(getPatientInfo({ patientId: window.value.patientId }));
    //                 getPatientData(window.value.patientId)
    //                 getCcmPlan(window.value.patientId)
    //                 setFirstCall(true)
    //         }
    //     }, 1000);
    //     setLoading(false)
    //     return () => clearTimeout(timer);

    // }, [window.token]);

    useEffect(() => {
        setTimeout(() => {
            if (window.value !== undefined && window.token !== undefined && firstCall === false) {
                getPatientData(window.value.patientId)
                setFirstCall(true)
            }
        }, 1000)
    }, [window.token]) //eslint-disable-line

    const getCcmPlan = async patientID => {
        const res = await TempAxiosGet(
            window.token,
            `/api/pcm/careplan/principalCare/latest/${patientID}/fetch`
        )
        setCarePlanData(res?.details)

        if (!res?.details?.plan?.planIcds) getIcds(patientID)
        if (res?.details?.plan?.providers) {
            setProviders(res?.details?.plan?.providers)
            setPractitioners(res?.details?.plan?.practitioners)
        } else if (res?.details?.plan?.provider) {
            setProviders([`${res?.details?.plan?.provider?.providerFirstName && res?.details?.plan?.provider?.providerFirstName !== "" ? " " + res?.details?.plan?.provider?.providerFirstName : ""}
            ${res?.details?.plan?.provider?.providerMiddleName && res?.details?.plan?.provider?.providerMiddleName !== "" ? " " + res?.details?.plan?.provider?.providerMiddleName : ""} 
            ${res?.details?.plan?.provider?.providerLastName && res?.details?.plan?.provider?.providerLastName !== "" ? " " + res?.details?.plan?.provider?.providerLastName : ""}`])
        } else {
            getProvider(patientID)
        }
    }

    const getPatientData = async patientId => {
        const res = await TempAxiosGet(window.token, `/api/cs/patients/${patientId}/profile`)
        if (res?.status === 200) {
            setPatientInfoDetail(res?.details)
            await getCcmPlan(patientId)
            setLoading(false)
        }
    }

    const getIcds = async patientID => {
        const res = await TempAxiosGet(window.token, `/api/cs/patients/diagnostic/${patientID}/fetch`)
        setIcdCodes(res?.details?.map(({ icdCode }) => icdCode))
    }

    const getProvider = async patientID => {
        const res = await TempAxiosGet(window.token, `/api/cs/patients/monitoring/${patientID}/fetch`)
        let provider = []
        let practitioner = []

        if (res?.details?.pcm?.[0]) {
            provider = res?.details?.pcm?.[0]?.providerId ? [` ${res?.details?.pcm?.[0]?.providerfirstName}
      ${res?.details?.pcm?.[0]?.providerMiddleName && res?.details?.pcm?.[0]?.providerMiddleName !== "" ? " " + res?.details?.pcm?.[0]?.providerMiddleName : ""} 
      ${res?.details?.pcm?.[0]?.providerLastName}`] : []
        }
        if (res?.details?.pcm?.[0]) {
            practitioner = res?.details?.pcm?.[0]?.practitionerId ? [` ${res?.details?.pcm?.[0]?.practitionerfirstName}
      ${res?.details?.pcm?.[0]?.practitionerMiddleName && res?.details?.pcm?.[0]?.practitionerMiddleName !== "" ? " " + res?.details?.pcm?.[0]?.practitionerMiddleName : ""} 
      ${res?.details?.pcm?.[0]?.practitionerLastName}`] : []
        }

        setProviders(provider)
        setPractitioners(practitioner)
    }

    return (
        <>
            <Helmet>
                <script>{`
                function fillDetails(jsonData) {
                var content = JSON.parse(decodeURIComponent(jsonData))
                // var content = {"token":"eyJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJzZWxmIiwic3ViIjoiNDMzOTYwOWMtN2M1MC00YTgyLWI2MTctYzBkOGRmZjc3NGVlIiwiZXhwIjoxNzE1MDkwOTU1LCJpYXQiOjE3MTUwODczNTUsInNjb3BlIjoiY2FyZXRha2VyX2FsbCJ9.L9LWp1xxe89gZeoJVF8PX_gIJwTzI7ebB8i8dBE4Aq7TxgBWeNls5WNpJmzzw9SDTiCbldOrMATsfuMj3x--Piq8CLVdxVaEAK2NwEGKfcn81uEqSmLKJds1Zu5snIfhGxZPs-Zq0eKwR2xnxXzbx2atWTkagbFlHqU30wP5CEoppGD4tj43oMtqk4SRPwBu0OFQVPwGUtKxpA8xlOU0M0f83XNdK7p5gB05yxfyIEH3_HHk3t7nJyknc5ZfYlRPLLox8IeLR3x6nyeA95mEtJsdx1QxbnezanUH_ZDY4OkcvaKhkr7GEM_UzUcuhQF0yId1ZkeEV1aYPIlzp7F8lg", patientId:"57a04747-7fb0-4f51-9277-4b15d422f136"};
                
                window.isMobileVersion = true;
                window.value = content;
                window.token = content.token; 
                }`}</script>
            </Helmet>
            {loading & !carePlanData ? (
                <Loading />
            ) : (
                (patientInfoDetail !== undefined && carePlanData && (
                    <PlanView
                        type="pcm"
                        planDate={carePlanData?.planDate}
                        providers={providers}
                        practitioners={practitioners}
                        patientInfoDetail={patientInfoDetail}
                        plan={convertCareplanToV2(carePlanData?.plan)}
                        planIcds={carePlanData?.plan?.planIcds ?? icdCodes}
                        addedBy={carePlanData?.plan?.addedBy}
                        serviceDate={getDateOfService(carePlanData?.planDate)}
                    />
                )) || (
                    <Typography.Title level={4} className="mt-3 text-center">
                        No plan found
                    </Typography.Title>
                ))
            }
        </>
    )
}

export default MobilePCM
